var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "register-card"
  }, [_c("section", {
    staticClass: "register-card__left"
  }, [_c("h4", {
    staticClass: "puhui-M"
  }, [_vm._v("注册账号")]), _c("section", {
    staticClass: "register-flag login-form"
  }, [_c("a-form", {
    attrs: {
      form: _vm.form,
      autoComplete: "off"
    },
    on: {
      submit: _vm.handleSubmit
    }
  }, [_c("a-form-item", [_c("a-input", {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: ["email", {
        rules: [{
          required: true,
          message: "请输入工作邮箱!"
        }, {
          message: "请输入正确的邮箱格式!",
          type: "email",
          pattern: /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
        }],
        validateTrigger: "blur"
      }],
      expression: "[\n              'email',\n              {\n                rules: [\n                  {\n                    required: true,\n                    message: '请输入工作邮箱!',\n                  },\n                  {\n                    message: '请输入正确的邮箱格式!',\n                    type: 'email',\n                    pattern: /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\\.[a-zA-Z0-9_-]+)+$/,\n                  },\n                ],\n                validateTrigger: 'blur',\n              },\n            ]"
    }],
    attrs: {
      allowClear: "",
      placeholder: "请输入您的工作邮箱",
      size: "large"
    }
  })], 1), _c("a-form-item", [_c("a-input", {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: ["name", {
        rules: [{
          required: true,
          message: "请输入姓名!",
          min: 1
        }],
        validateTrigger: "blur"
      }],
      expression: "[\n              'name',\n              {\n                rules: [\n                  {\n                    required: true,\n                    message: '请输入姓名!',\n                    min: 1,\n                  },\n                ],\n                validateTrigger: 'blur',\n              },\n            ]"
    }],
    attrs: {
      allowClear: "",
      placeholder: "请输入您的姓名",
      size: "large"
    }
  })], 1), _c("a-form-item", [_c("a-input", {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: ["company", {
        rules: [{
          required: true,
          message: "请输入公司!",
          max: 50
        }],
        validateTrigger: "blur"
      }],
      expression: "[\n              'company',\n              {\n                rules: [\n                  {\n                    required: true,\n                    message: '请输入公司!',\n                    max: 50,\n                  },\n                ],\n                validateTrigger: 'blur',\n              },\n            ]"
    }],
    attrs: {
      allowClear: "",
      placeholder: "请输入您的公司",
      size: "large"
    }
  })], 1), _c("a-form-item", [_c("a-input", {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: ["department", {
        rules: [{
          required: true,
          message: "请输入部门名称"
        }]
      }],
      expression: "[\n              'department',\n              {\n                rules: [{ required: true, message: '请输入部门名称' }],\n              },\n            ]"
    }],
    attrs: {
      allowClear: "",
      placeholder: "请输入所在部门",
      size: "large"
    }
  })], 1), _c("a-form-item", [_c("a-input", {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: ["mobile", {
        rules: [{
          required: true,
          message: "请输入手机号!"
        }, {
          message: "请输入正确的手机号!",
          pattern: /^1[3-9]\d{9}$/
        }],
        validateTrigger: "change"
      }],
      expression: "[\n              'mobile',\n              {\n                rules: [\n                  {\n                    required: true,\n                    message: '请输入手机号!',\n                  },\n                  {\n                    message: '请输入正确的手机号!',\n                    pattern: /^1[3-9]\\d{9}$/,\n                  },\n                ],\n                validateTrigger: 'change',\n              },\n            ]"
    }],
    attrs: {
      allowClear: "",
      placeholder: "请输入您的手机号",
      size: "large"
    }
  })], 1), _c("a-form-item", [_c("a-input", {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: ["code", {
        rules: [{
          required: true,
          message: "请输入邮箱验证码!"
        }]
      }],
      expression: "[\n              'code',\n              {\n                rules: [{ required: true, message: '请输入邮箱验证码!' }],\n              },\n            ]"
    }],
    attrs: {
      allowClear: "",
      placeholder: "请输入邮箱验证码",
      size: "large"
    }
  }, [_c("template", {
    slot: "suffix"
  }, [_c("Captcha", {
    ref: "captcha",
    on: {
      send: _vm.handleSendCaptcha
    }
  })], 1)], 2)], 1), _c("a-form-item", {
    staticClass: "checkbox-formitem",
    staticStyle: {
      "margin-bottom": "16px"
    }
  }, [_c("a-checkbox", {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: ["agreement", {
        initialValue: true,
        valuePropName: "checked",
        rules: [{
          required: true,
          validator: (rule, value, callback) => value ? callback() : callback("请勾选用户协议、隐私政策")
        }]
      }],
      expression: "[\n              'agreement',\n              {\n                initialValue: true,\n                valuePropName: 'checked',\n                rules: [\n                  {\n                    required: true,\n                    validator: (rule, value, callback) =>\n                      value ? callback() : callback('请勾选用户协议、隐私政策'),\n                  },\n                ],\n              },\n            ]"
    }]
  }, [_c("span", {
    staticClass: "agree-prefix"
  }, [_vm._v("我已阅读并同意")]), _c("span", {
    staticClass: "agreement",
    on: {
      click: function ($event) {
        $event.preventDefault();
        return _vm.handleViewAgreement.apply(null, arguments);
      }
    }
  }, [_vm._v("《同花顺用户服务协议》")])])], 1), _c("a-form-item", [_c("button", {
    staticClass: "custom-btn login-btn",
    attrs: {
      type: "submit"
    }
  }, [_vm._v("注 册")])])], 1)], 1), _c("section", {
    staticClass: "bottom"
  }, [_c("a-popover", {
    attrs: {
      title: "邮箱无法获取验证码",
      overlayStyle: {
        width: "265px"
      }
    }
  }, [_c("template", {
    slot: "content"
  }, [_c("p", [_vm._v("1. 请到邮箱垃圾桶里确认验证码是否被拦截；")]), _c("p", [_vm._v("2. 如邮箱已被注册，请联系同花顺销售同事进行处理")])]), _c("span", [_vm._v("无法接收验证码?")])], 2), _c("div", {
    staticClass: "register"
  }, [_c("span", [_vm._v("已有账号？")]), _c("span", {
    on: {
      click: _vm.goLogin
    }
  }, [_vm._v("去登录")])])], 1)]), _c("section", {
    staticClass: "register-card__right"
  }, [_c("LoginService", {
    attrs: {
      title: "欢迎您注册体验"
    }
  })], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };